import React from 'react';

import classNames from 'classnames';

import styles from './Description.module.css';

type DescriptionProps = {
  description: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export const Description = ({
  description,
  id,
  className,
  ...props
}: DescriptionProps) => {
  return (
    <span
      className={classNames(styles.description, className)}
      id={id}
      {...props}
    >
      {description}
    </span>
  );
};
